import { render, staticRenderFns } from "./admins.vue?vue&type=template&id=2f2ccdfc&"
import script from "./admins.vue?vue&type=script&lang=js&"
export * from "./admins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports